import { Box } from "@mui/material";

import { PLOT_MAP_LAYERS } from "components/PlotMap/utils/layerPrefs";
import type { PlotMapLayer } from "defs";

interface LayerSwatchProps {
  layer: PlotMapLayer;
}

const LayerSwatch: React.FC<LayerSwatchProps> = ({ layer }) => {
  return (
    <Box
      aria-hidden
      component="span"
      sx={{
        borderRadius: 0.5,
        display: "inline-block",
        flexShrink: 0,
        height: 16,
        width: 22,
        ...PLOT_MAP_LAYERS[layer].swatchSx,
      }}
    />
  );
};

export default LayerSwatch;
